export default __webpack_public_path__ + "assets/loader-big.939c68e755cf14fab3471f41ba659ee2.gif";